import { render } from "./VerticalAligner.vue?vue&type=template&id=0980e830"
import script from "./VerticalAligner.vue?vue&type=script&lang=js"
export * from "./VerticalAligner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/common/VerticalAligner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0980e830"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0980e830', __exports__)) {
    api.reload('0980e830', __exports__)
  }
  
  module.hot.accept("./VerticalAligner.vue?vue&type=template&id=0980e830", () => {
    api.rerender('0980e830', render)
  })

}


export default __exports__